import i18n from '../libs/i18n/i18n';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const CLIENT = process.env.REACT_APP_CLIENT || 'tuid';

export const validateDocument = async (data, fileBlob, file, fileBlobOrigin, fileOrigin) => {
    const url = `${BASE_URL}/verifier/document?idpid=tx`;

    const formData = new FormData();
    formData.append("extended_report", data.extended_report);
    formData.append("report_type", data.report_type);
    formData.append("verify_incremental_updates", data.verify_incremental_updates);
    formData.append("show_payload_json", data.show_payload_json);
    formData.append("emit_receipt", data.emit_receipt);
    formData.append('signature_files', fileBlob, file.name);
    if (null !== fileBlobOrigin) {
        formData.append('detached_files', fileBlobOrigin, fileOrigin.name);
    }
    const response = await fetch(url, {
        method: 'POST',
        body: formData
    });

    if (!response.ok) {
        throw new Error('Failed to validate document');
    }

    return await response.json();
};

export const validateRseDocument = async (fileBlob, file) => {
    const currentLanguage = i18n.resolvedLanguage || i18n.language || 'es';
    const language = currentLanguage.toLowerCase().startsWith('en') ? 'en' : 'es';
    const url = `${BASE_URL}/verifier/rse/document?idpid=tx&client=${encodeURIComponent(CLIENT)}&language=${language}`;

    const formData = new FormData();
    formData.append('file', fileBlob, file.name);

    const response = await fetch(url, {
        method: 'POST',
        body: formData
    });

    if (!response.ok) {
        throw new Error('Failed to validate RSE document');
    }

    return await response.json();
};
